jQuery(document).ready(function ($) {
    $(".faq-question").on("click", function () {
        let item = $(this).closest(".faq-item");
        let answer = item.find(".faq-answer");

        // Toggle the clicked item with a smooth slide effect
        if (item.hasClass("active")) {
            item.removeClass("active");
            answer.stop().slideUp(6000); // Smoothly close the current answer
        } else {
            // Close other open answers
            $(".faq-item.active").removeClass("active").find(".faq-answer").stop().slideUp(6000);

            // Open the clicked answer
            item.addClass("active");
            answer.stop().slideDown(6000); // Smoothly open the clicked answer
        }
    });
});
